module.exports = __webpack_public_path__ + "static/media/EMS-on.f50a150c.svg";